import React, { useContext, useMemo } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { InfluencerContext } from '../../../../contexts/InfluencerContext'
import Authentication from '../../../../models/Authentication'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import { observer } from 'mobx-react-lite'

import { formatNumber } from '../../../../utils/Helper'

export default observer(function SimilarInfluencers() {
  const { id } = useParams()
  const navigate = useNavigate()
  const { authentications } = useContext(InfluencerContext)

  const currentAuthentication = useMemo(() => authentications.find(authentication => +authentication.id === +id ) || new Authentication(), [id, authentications, authentications.length] )

  // const openAuthentication = id => () => navigate(`/project_manager/authentications/${id}/influencer/overview`)

  return (
    <div className="bg-rb-grey dark:bg-rb-dark-mode-background p-4">
      <div className="flex flex-wrap gap-4">
        {currentAuthentication.similar_authentications.map(authentication => {
          const avatarUrl = typeof authentication.avatar === 'string' ? authentication.avatar : authentication.avatar?.url
          return (
          <div key={authentication.id} className="rounded-lg bg-white dark:bg-rb-dark-mode p-4 flex w-84 border border-gray-200 dark:border-rb-dark-mode-lighter">
            <img src={avatarUrl} alt={avatarUrl} className="w-18 h-18 rounded-lg" />
            <div className="flex flex-col justify-between ml-4 w-full">
              <div className="flex justify-between">
                <Link to={`/project_manager/authentications/${authentication.id}/influencer/overview`} className="text-sm font-bold hover:underline dark:text-white">{authentication.username}</Link>
                <p className="">{authentication.country && getUnicodeFlagIcon(authentication.country)}</p>
              </div>
              <div className="flex justify-between">
                <p className="text-sm mr-4 dark:text-white">Follower <span className="font-bold dark:text-white">{formatNumber(authentication.reach)}</span></p>
                <p className="text-sm dark:text-white">Eng. rate <span className="font-bold dark:text-white">{(authentication.engagement_rate * 100).toFixed(2)}%</span></p>
              </div>
            </div>
          </div>
          )
        })}
      </div>
    </div>
  )
})